// Account
export const GET_ACCOUNT = 'GET_ACCOUNT';
export const GET_USERS = 'GET_USERS';
export const GET_USER = 'GET_USER';

// URL Lookup
export const URL_LOOKUP = 'URL_LOOKUP';

// List lookup
export const GET_ALL_LISTS = 'GET_ALL_LISTS';
export const GET_LIST = 'GET_LIST';
export const GET_LIST_ENTRIES = 'GET_LIST_ENTRIES';
export const SET_LIST_ENTRY = 'SET_LIST_ENTRY';

// Auth
export const CHECK_AUTHENTICATION = 'CHECK_AUTHENTICATION';
export const LOGOUT = 'LOGOUT';
export const LOGIN = 'LOGIN';
export const SELECT_CUSTOMER = 'SELECT_CUSTOMER';



// WEBPACK FOOTER //
// ./src/app/store/mutation-types.js